/**
 * @prettier
 */

import createBehavior from '@js/functions/createBehavior.js';

const linkTargetBlankBehavior = createBehavior(
  'link-target-blank',
  {
  },
  {
    init() {
      this.node.querySelectorAll('a').forEach($a => {
        $a.target = "_blank";
      });
    },
    destroy() {},
  },
);

export default linkTargetBlankBehavior;
